import { render } from "./PortfolioProjectCovers.vue?vue&type=template&id=59a5a4d0&scoped=true"
import script from "./PortfolioProjectCovers.vue?vue&type=script&lang=ts"
export * from "./PortfolioProjectCovers.vue?vue&type=script&lang=ts"

import "./PortfolioProjectCovers.vue?vue&type=style&index=0&id=59a5a4d0&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-59a5a4d0"

export default script